import { render, staticRenderFns } from "./vCard.vue?vue&type=template&id=fc4c6064&"
import script from "./vCard.vue?vue&type=script&lang=js&"
export * from "./vCard.vue?vue&type=script&lang=js&"
import style0 from "./vCard.vue?vue&type=style&index=0&id=fc4c6064&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports